import PropTypes from "prop-types";
// material
import { Paper, Typography } from "@mui/material";

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = "", ...other }: any) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Sem resultados para exibir
      </Typography>
      <Typography variant="body2" align="center">
        Não existem resultados para &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Substitua o texto, e tente
        novamente.
      </Typography>
    </Paper>
  );
}
